<template>
  <el-main>
    <div class="top-section">
      <el-row class="list-header">
        <el-col :span="24" class="section-header" :gutter="20">
          <div class="section-title">Opciones</div>
        </el-col>
      </el-row>
    </div>

    <div class="cards-opt">

      <el-row class="card-row row-1" :gutter=20 justify="center">
        <el-col class="card-col" :xs="22" :sm="22" :md="10" :lg="10" :xl="10">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <div class="card-title"><strong>Calculadora de Inversión Aseguradora vs Tradicional</strong></div>
              <el-button class="card-button" style="float: right" type="primary" v-on:click="goToAnalysis(1)">Iniciar</el-button>

            </div>
            <span class="card-body">Calculadora de Inversión Aseguradora vs Tradicional</span>

          </el-card>
        </el-col>
        <el-col class="card-col" :xs="22" :sm="22" :md="10" :lg="10" :xl="10">

            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <div class="card-title"><strong>Opción 2</strong></div>
                <el-button class="card-button" style="float: right" type="primary" v-on:click="goToAnalysis(2)" disabled>Iniciar</el-button>

              </div>
              <span class="card-body">Descripción</span>

            </el-card>
          </el-col>
      </el-row>

      <el-row class="card-row row-2" :gutter="20" justify="center">
        <el-col class="card-col" :xs="22" :sm="22" :md="10" :lg="10" :xl="10">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <div class="card-title"><strong>Opción 3</strong></div>
              <el-button class="card-button" style="float: right" type="primary" v-on:click="goToAnalysis(3)" disabled>Iniciar</el-button>

            </div>
            <span class="card-body">Descripción</span>

          </el-card>
        </el-col>
        <el-col class="card-col" :xs="22" :sm="22" :md="10" :lg="10" :xl="10">

          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <div class="card-title"><strong>Opción 4</strong></div>
              <el-button class="card-button" style="float: right" type="primary" v-on:click="goToAnalysis(4)" disabled>Iniciar</el-button>

            </div>
            <span class="card-body">Descripción</span>

          </el-card>
        </el-col>
      </el-row>

    </div>

  </el-main>

</template>

<script>
    export default {
        name: "Calculator",
        methods: {
            goToAnalysis (index) {
                //this.$store.dispatch('resetPortfolioForm')
                //this.$store.dispatch('setFormMode', 1)
                //alert(index)
                if (index === 1){

                    this.$router.push('/calculadora/opcion1')

                }

            },
        }
    }


</script>

<style scoped>

  .el-main {
    line-height: 10px;
  //display: flex;
  //flex-direction: column;
  //justify-content: center;
  }

  .top-section {
    margin: 25px 0 38px 50px;
  }

  .list-header {
    margin: 25px 0 38px 0;
  }

  .section-header {
    width: 100%;
    margin: 0 auto;
  //display: flex;
  //flex-direction: column;
  //align-content: flex-center;
    padding: 10px;
  //overflow:hidden;
  }

  .section-title {
    font-size: 18px;
    font-weight: 600;
    word-wrap: break-word;
    text-align: start;
  }

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 20px;
    }
  }

  .card-row{
    margin: 40px 0 38px 50px;
  }

  /* Blue button */
  .card-button{
    cursor: pointer;
    border-radius: 5px;
    border-color: #f5f7fa;
    font-size: 16px;
  }

  // CARDS VIEW

  .box-card {
  //width: fit-content;
    height:20vh;
  //width: calc(100% - 800px);
    margin-bottom: 20px;
  }

  .card-col{
    margin-bottom: 20px;
  }

  .card-title{
    font-size: 18px;
    color: #ffffff;
    text-align: start;
    font-weight: 500;
    line-height: 16px;
    padding-bottom: 10px;
    height: 6vh;
  }

  .card-body{
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card /deep/ .el-card__header {
    background-color: #001F5C;
    border-bottom: 2px solid #f56c6c;
    //height: 10vh;
  }

  .card-col /deep/ .el-card {
    border-radius: 20px;
    border: 2px solid #001F5C;
  }

  .cards-opt{
    //width: 100%;
    //height: 100%;
    margin: 25px 0 38px 50px;
  }


</style>




// WEBPACK FOOTER //
// src/components/Calculator.vue